export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/login.vue'),
    meta: {
      title: 'Вход',
      wfPage: '66628b11ce9ac8f5a081c327'
    }
  }
];
